export default "__VITE_ASSET__CNv8jeDq__"